<template>
  <h1
    v-if="productTitles.subtitle && !isMasterPPScaleUrl"
    class="mb-8 flex flex-col"
  >
    <span class="heading-1">{{ productTitles.default }}</span>
    <span class="body-2">{{ productTitles.subtitle }}</span>
  </h1>

  <h1 v-else class="heading-1 mb-8">
    {{ productTitles.default }}
  </h1>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import { PRODUCT } from '../../route-names'

defineProps<{
  productTitles: GetProductResponse['titles']
}>()

const route = useRoute()

const isMasterPPScaleUrl = computed(() => {
  return route.name === PRODUCT.MASTER_PP
})
</script>
